import React from 'react';
import { PiPlusCircle } from "react-icons/pi";

interface AddTemplateCardProps {
  onClick: () => void;
}

const AddTemplateCard: React.FC<AddTemplateCardProps> = ({ onClick }) => {
  return (
    <div 
      className="card bg-[#F6F7FC] rounded-3xl w-56 shadow-sm mt-1 
        transition duration-150 ease-in-out hover:-translate-y-0.5 hover:scale-102 hover:shadow-xl
        relative font-inter cursor-pointer border-2 border-dashed border-gray-300 hover:border-gray-400
        flex items-center justify-center"
      onClick={onClick}
    >
      <div className="card-body p-4 flex flex-col items-center justify-center text-center">
        <PiPlusCircle className="text-4xl text-[#7C7C8A] mb-2" />
        <div className="text-[16px] text-[#242630] font-medium">添加自定义模板</div>
        {/* <div className="text-[14px] text-[#242630] mt-1 opacity-60">创建专属模板</div> */}
      </div>
    </div>
  );
};

export default AddTemplateCard;